import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUser } from '../context/UserContext';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import  QRCodeBox  from '../components/UI/QRCodeBox';
import  Select from '../components/UI/Select';
import  Table  from '../components/UI/Table';
import actionLabels from '../config/actionLabels';

export const QRListPage = () => {
    const [qrCodes, setQrCodes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { register, watch } = useForm({
        defaultValues: {
            type: 'all',
            dateFrom: '',
            dateTo: ''
        }
    });
	const { logout } = useUser();
    const type = watch('type');
    const dateFrom = watch('dateFrom');
    const dateTo = watch('dateTo');

    useEffect(() => {
        fetchQRCodes();
    }, [type, dateFrom, dateTo]);

    const fetchQRCodes = async () => {
        try {
            setIsLoading(true);
            const queryParams = new URLSearchParams();
            if (type !== 'all') queryParams.append('type', type);
            if (dateFrom) queryParams.append('dateFrom', dateFrom);
            if (dateTo) queryParams.append('dateTo', dateTo);

            const response = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/qr?${queryParams.toString()}`,
                {},
                logout
            );
            const data = await response.json();
            setQrCodes(data);
        } catch (error) {
            console.error('Ошибка при загрузке QR кодов:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const columns = [
        { header: 'QR код', accessor: 'qrCode' },
        { header: 'Тип', accessor: 'type', render: (type) => actionLabels[type] },
        { header: 'Объект', accessor: 'objectId' },
        { header: 'Описание', accessor: 'description' },
        { header: 'Дата создания', accessor: 'createdAt' },
        { header: 'Действия', accessor: 'actions' }
    ];

	const objectFormatters = {
		product: (obj) => obj && typeof obj === 'object'
			? `${obj.name || ''} (${obj.article || ''})`.trim() || 'Объект удален'
			: 'Объект удален',
	
		order: (obj) => obj?.productSnapshot?.name || 'Заказ удален',
	
	};
	

	const data = qrCodes.map(qr => {
		const formatter = objectFormatters[qr.type];
		
		return {
			qrCode: <QRCodeBox qrCodePath={qr.qrCodePath} withActions />,
			type: qr.type,
			objectId: formatter ? formatter(qr.objectId) : '—',
			description: qr.description,
			createdAt: new Date(qr.createdAt).toLocaleDateString(),
			actions: (
				<button 
					onClick={() => handleDelete(qr._id)}
					className="text-red-500 hover:text-red-700"
				>
					Удалить
				</button>
			)
		};
	});
	

    const handleDelete = async (id) => {
        if (window.confirm('Вы уверены, что хотите удалить этот QR код?')) {
            try {
                await fetchWithAuth(`${process.env.REACT_APP_API_URL}/qr/${id}`, {
                    method: 'DELETE'
                }, logout);
                fetchQRCodes();
            } catch (error) {
                console.error('Ошибка при удалении QR кода:', error);
            }
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Список QR кодов</h1>
            
            <div className="mb-4 flex gap-4">
                <Select
                    {...register('type')}
                    options={[
                        { value: 'all', label: 'Все типы' },
                        { value: 'product', label: 'Продукты' },
                        { value: 'order', label: 'Заказы' },
                        { value: 'inventory', label: 'Инвентарь' },
                    ]}
                />
                
                <input
                    type="date"
                    {...register('dateFrom')}
                    className="border rounded p-2"
                />
                
                <input
                    type="date"
                    {...register('dateTo')}
                    className="border rounded p-2"
                />
            </div>

            {isLoading ? (
                <div>Загрузка...</div>
            ) : (
                <Table columns={columns} data={data} />
            )}
        </div>
    );
}; 